import { Action, Dispatch } from 'redux';
import { Partner, PartnerAddress } from './types';
import { ReduxAction, failure, pending, success } from '../../core';

import { HealAPI } from '../../../healApi';
import { ThunkAction } from 'redux-thunk';
import { UIAction } from '../../ui/actions';

export class PartnerActions {
  private static area = 'PARTNERS';

  public static SET_PARTNERS_IS_FETCHING = `${PartnerActions.area}_SET_PARTNERS_IS_FETCHING`;
  public static SET_PARTNERS = `${PartnerActions.area}_SET_PARTNERS`;
  public static SET_PARTNERS_ERROR = `${PartnerActions.area}_SET_PARTNERS_ERROR`;

  public static CREATE_PARTNER = `${PartnerActions.area}_CREATE_PARTNER`;
  public static EDIT_PARTNER = `${PartnerActions.area}_EDIT_PARTNER`;

  public static CREATE_PARTNER_ADDRESS = `${PartnerActions.area}_CREATE_PARTNER_ADDRESS`;
  public static EDIT_PARTNER_ADDRESS = `${PartnerActions.area}_EDIT_PARTNER_ADDRESS`;

  public static UPLOAD_LOGO = `${PartnerActions.area}_UPLOAD_LOGO`;
}

export function setPartnerError(value: string): ReduxAction<string> {
  return {
    type: PartnerActions.SET_PARTNERS_ERROR,
    data: value,
  };
}

export function fetchPartners(): ThunkAction<any, any, any, any> {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: PartnerActions.SET_PARTNERS_IS_FETCHING, data: true });

    return HealAPI.fetchPartners()
      .then((response) => {
        if (response.ok) {
          dispatch({ type: PartnerActions.SET_PARTNERS, data: response.data });
          dispatch({ type: PartnerActions.SET_PARTNERS_ERROR, data: undefined });
          dispatch({ type: PartnerActions.SET_PARTNERS_IS_FETCHING, data: false });
        } else {
          dispatch({ type: PartnerActions.SET_PARTNERS_ERROR, data: response.data });
          dispatch({ type: PartnerActions.SET_PARTNERS_IS_FETCHING, data: false });
        }
      })
      .catch((error) => {
        dispatch({ type: PartnerActions.SET_PARTNERS_ERROR, data: error });
        dispatch({ type: PartnerActions.SET_PARTNERS_IS_FETCHING, data: false });
      });
  };
}

export function createPartner(newPartner: Partner): ThunkAction<any, any, any, any> {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: pending(PartnerActions.CREATE_PARTNER) });
    return HealAPI.createPartner(newPartner)
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: success(PartnerActions.CREATE_PARTNER),
            data: { value: response.data },
          });
          dispatch({ type: UIAction.SET_PARTNER_ACTIVE_KEY, data: response.data!.id });
        } else {
          dispatch({ type: failure(PartnerActions.CREATE_PARTNER), data: response.data });
        }
      })
      .catch((error) => {
        dispatch({ type: failure(PartnerActions.CREATE_PARTNER), data: error });
      });
  };
}

export function editPartner(editPartnerInfo: Partner): ThunkAction<any, any, any, any> {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: pending(PartnerActions.EDIT_PARTNER) });

    return HealAPI.editPartner(editPartnerInfo)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: success(PartnerActions.EDIT_PARTNER), data: { value: response.data } });
          dispatch(fetchPartners() as any);
        } else {
          dispatch({ type: failure(PartnerActions.EDIT_PARTNER), data: response.data });
        }
      })
      .catch((error) => {
        dispatch({ type: failure(PartnerActions.EDIT_PARTNER), data: error });
      });
  };
}

export function editPartnerAddress(partnerId: string, address: PartnerAddress) {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: pending(PartnerActions.EDIT_PARTNER_ADDRESS) });

    return HealAPI.editPartnerAddress(partnerId, address)
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: success(PartnerActions.EDIT_PARTNER_ADDRESS),
            data: { value: response.data },
          });
        } else {
          dispatch({ type: failure(PartnerActions.EDIT_PARTNER_ADDRESS), data: response.data });
        }
      })
      .catch((error) => {
        dispatch({ type: failure(PartnerActions.EDIT_PARTNER_ADDRESS), data: error });
      });
  };
}

export function createPartnerAddress(partnerId: string, address: PartnerAddress) {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: pending(PartnerActions.CREATE_PARTNER_ADDRESS) });

    return HealAPI.createPartnerAddress(partnerId, address)
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: success(PartnerActions.CREATE_PARTNER_ADDRESS),
            data: { value: response.data, partnerId },
          });
        } else {
          dispatch({ type: failure(PartnerActions.CREATE_PARTNER_ADDRESS), data: response.data });
        }
      })
      .catch((error) => {
        dispatch({ type: failure(PartnerActions.CREATE_PARTNER_ADDRESS), data: error });
      });
  };
}

export function uploadLogo(file: FormData) {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: pending(PartnerActions.UPLOAD_LOGO) });

    return HealAPI.uploadImage(file)
      .then((response) => {
        if (response.ok) {
          dispatch({ type: success(PartnerActions.UPLOAD_LOGO), data: { value: response.data } });
        } else {
          dispatch({ type: failure(PartnerActions.UPLOAD_LOGO), data: response.data });
        }
      })
      .catch((error) => {
        dispatch({ type: failure(PartnerActions.UPLOAD_LOGO), data: error });
      });
  };
}
